module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-modal', {
    ref: "modalPopup",
    attrs: {
      "id": "modalPopup",
      "title": _vm.titel,
      "ok-title": "Ok",
      "close-title": "Cancel"
    },
    on: {
      "ok": _vm.onclick,
      "cancel": _vm.cancelclick
    }
  }, [_vm._t("default", null, {
    data: _vm.data
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89b03c5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/popup.vue
// module id = 249
// module chunks = 1